import React from "react";
import classes from "./HeadingText.scss";

import classNames from "classnames";

const HeadingText = props => {
  const { text } = props;

  return (
    <div
      className={classNames(
        "text-body text-textSubtle",
        classes.headingWrapper
      )}
    >
      {text}
    </div>
  );
};

export default HeadingText;
